module.exports = __webpack_public_path__ + "media/student_v2/assets/images/book_pencil-b9577efe4d81f7f6b5f6dee16b7ead2a.svg";